import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IcMoreVertical } from '../../theme/icons';
import logoKi from '../assets/logo-ki.png';

/**
 * Mobile top app bar: the Kipara logo (centered, taps to home) and the ⋮ "More"
 * button. No back button — navigation is handled by the bottom tab bar. Page
 * titles live inside each page, not here.
 */
export default function MobileHeader({ onMenu, badge = 0 }) {
  const navigate = useNavigate();

  // Frame Ki Para (Brand Kit §06, livre 2026-09-04) : dégradé 180° #111827 →
  // #000, logo blanc exact 30 px — jamais recoloré ; ⋮ gris #9CA3AF (gray-400,
  // le #8B93A5 du mock n'est pas dans la palette) ; bulle #DC2626 blanc 9 px
  // 700, padding 1/5 px, sans liseré. Cibles ≥ 44 px (règles absolues).
  return (
    <header
      className="fixed top-0 inset-x-0 z-40 h-14 flex items-center px-2 text-white bg-gradient-to-b from-gray-900 to-black shadow-md"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      {/* Spacer balances the menu button so the logo stays centered.
          (Connectivity light now lives in the footer.) */}
      <div className="w-9 shrink-0" />

      <button
        onClick={() => navigate('/')}
        aria-label="Accueil"
        className="flex-1 flex justify-center px-1 active:opacity-80"
      >
        <img src={logoKi} alt="Ki Para" className="h-9 w-auto object-contain" />
      </button>

      <button
        onClick={onMenu}
        aria-label={badge > 0 ? `Menu — ${badge} note(s) non lue(s)` : 'Menu'}
        className="relative p-2 rounded-full text-gray-400 active:bg-white/10 shrink-0"
      >
        <IcMoreVertical className="text-lg" />
        {badge > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center">
            {badge > 99 ? '99+' : badge}
          </span>
        )}
      </button>
    </header>
  );
}
